import * as Yup from 'yup';

const userValidation = (t: (key: string) => string) => ({
  resetPassword: Yup.object().shape({
    new_password: Yup.string().required(t('resetPassword.newPasswordRequired')),
    new_password_confirmation: Yup.string().oneOf([Yup.ref('new_password')], t('resetPassword.newPasswordConfirm')),
  }),
  upsertClient: Yup.object().shape({
    name: Yup.string().required(t('edit.namRequired')),
    username: Yup.string().required(t('edit.usernameRequired')),
  }),
  upsertContract: Yup.object().shape({
    contract_id: Yup.string().required(t('edit.contractIdRequired')),
    name2: Yup.string().required(t('edit.representativeRequired')),
    email: Yup.string().required(t('edit.emailRequired')),
    phone: Yup.string().required(t('edit.phoneRequired')),
  }),
  assignToTechnician: Yup.object().shape({
    technician: Yup.string().required(t('technicianRequired')),
  }),
});

export default userValidation;
